import React, { PropsWithChildren } from 'react'

const CONTAINER_STYLES = 'absolute right-0 top-100 w-screen'
const DROPDOWN_STYLES =
  'flex flex-col flex-grow w-screen sm:w-4/5 md:w-2/5 lg:w-1/5 xl:w-1/6 bg-navbackground text-white absolute top-0 right-0 z-20 border-l border-navdivider'

export const Dropdown: React.FC<PropsWithChildren> = ({ children }) => (
  <div className={CONTAINER_STYLES}>
    <nav className={DROPDOWN_STYLES}>{children}</nav>
  </div>
)
